var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonMacie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3332_2879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "url(#paint0_linear_3332_2879)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3335 25.1023C32.1027 24.1526 31.06 23.3533 30.1788 22.6947C31.216 20.8628 32.4293 18.7755 32.97 18.3377C34.4597 19.2587 39.2106 27.4812 39.5735 29.6383C38.4062 29.0167 35.5176 26.7881 33.3335 25.1023ZM23.8813 29.9968C23.5063 29.7659 22.7842 28.7489 21.9567 27.4449C22.1303 27.171 22.3148 26.8776 22.5126 26.5614C23.6297 24.7808 25.478 21.8327 26.1421 21.4414C26.5274 21.5607 27.4697 22.1942 28.6086 23.0246C27.232 25.465 24.8037 29.7451 23.8813 29.9968ZM19.0215 29.6102C18.6036 29.1306 17.8548 27.7896 17.383 26.9426C16.1903 24.8052 15.7458 24.0649 15.1137 24.0435C14.593 24.0244 14.0329 24.4986 11.8017 26.5262C10.9404 27.3094 9.67634 28.4584 8.80116 29.1247C10.035 26.4355 13.7988 19.835 15.0514 18.2309C15.62 19.0249 16.7698 21.0227 17.7254 22.681C18.8643 24.6597 19.78 26.2226 20.5324 27.4413C19.9384 28.3689 19.3578 29.2374 19.0215 29.6102ZM39.9219 27.0464C38.7812 24.4909 34.6146 17.1017 32.9537 17.1017C32.0979 17.1017 31.2396 18.386 29.202 21.9747C27.578 20.799 26.6466 20.2513 26.1391 20.2346C25.2198 20.2197 24.2261 21.5607 21.4838 25.9344C21.4082 26.0549 21.3301 26.1796 21.2503 26.3067C20.3842 24.8822 19.4788 23.3109 18.7772 22.0922C16.0567 17.3671 15.6774 16.8231 15.0901 16.8016C14.6758 16.7861 14.29 16.773 11.1715 22.1638C9.77251 24.5827 8.00158 27.8511 7.42034 29.3114C7.24313 29.7552 7.02357 30.3082 7.43183 30.6548C8.19815 31.3056 9.3951 30.3356 12.6219 27.4031C13.439 26.6598 14.5162 25.6815 15.0133 25.3349C15.3375 25.7519 15.9182 26.7923 16.3228 27.5176C17.6927 29.9735 18.2794 30.9035 19.0137 30.9244C19.0215 30.9244 19.0294 30.9244 19.036 30.9244C19.5568 30.9244 20.034 30.4167 21.2424 28.5621C22.5011 30.4883 23.2184 31.2 23.8311 31.2H23.8402C25.2143 31.1845 26.7306 28.799 29.5848 23.747C30.5852 24.4968 31.6527 25.32 32.5884 26.0418C38.8846 30.9005 39.8475 31.4726 40.514 30.7562C40.8866 30.3547 41.0735 29.6275 39.9219 27.0464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3332_2879",
    x1: 0,
    y1: 4800,
    x2: 4800,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5252"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3332_2879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonMacie);
export default __webpack_public_path__ + "static/media/Amazon_macie.d526bcbba06679e10a31890fc4606e9f.svg";
export { ForwardRef as ReactComponent };